import ContactList from "../../Join/Contact/ContactList";

const ConstactsTab = (props) => {
  return <ContactList {...props} />;
};

export default ConstactsTab;
